import PhotoUpload from "@/components/PhotoUpload";
import { CheckCircle2, Circle } from "lucide-react";

export default function EvidenceSlots({ slots, values, onChange, testId }) {
  const done = slots.filter((s) => values[s.key]).length;
  return (
    <div className="space-y-2" data-testid={`${testId}-slots`}>
      <div className="flex items-center justify-between text-xs">
        <span className="text-[#94A3B8]">Required evidence</span>
        <span className={`font-mono font-bold ${done === slots.length ? "text-emerald-400" : "text-amber-400"}`} data-testid={`${testId}-progress`}>
          {done}/{slots.length}
        </span>
      </div>
      <div className={`grid gap-2 ${slots.length >= 4 ? "grid-cols-2" : slots.length === 3 ? "grid-cols-3" : "grid-cols-2"}`}>
        {slots.map((s) => (
          <div key={s.key} className="space-y-1">
            <div className="flex items-center gap-1 text-[11px] text-[#94A3B8]">
              {values[s.key] ? <CheckCircle2 className="w-3 h-3 text-emerald-400" /> : <Circle className="w-3 h-3" />}
              <span className="truncate">{s.label}</span>
            </div>
            <PhotoUpload compact value={values[s.key] || null} accept={s.kind === "video" ? "video/*" : "image/*"}
              onChange={(p) => onChange({ ...values, [s.key]: p })}
              testId={`${testId}-${s.key}`} label={s.kind === "video" ? "Record video" : "Take photo"} />
          </div>
        ))}
      </div>
    </div>
  );
}
